import type { Router } from 'vue-router'
import { setDocumentTitle } from '@/utils/pageTitle'

/** Shows each route's static title once navigation succeeds; entity pages may refine it. */
export const installPageTitle = (router: Pick<Router, 'afterEach'>): void => {
  router.afterEach((to, _from, failure) => {
    if (failure) return
    setDocumentTitle(to.meta.pageTitle)
  })
}
